<template>
  <div id="signContract">
    <van-sticky>
      <div
        class="signContractNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">签署合同</span>
        <img
          class="navRight"
          @click="copy()"
          id="copy"
          src="./../../../assets/decoration/copy.png"
        />
      </div>
    </van-sticky>
    <div class="stepper-warpper">
      <van-stepper
        v-model="value"
        input-width="40px"
        step="0.2"
        :decimal-length="1"
        :disabled="isDisabled"
        @change="stepperOnchange"
      />
      <div class="percent">{{ percentValue }}</div>
    </div>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <!-- <img width="100%" height="100%" src="../../../assets/debtor/user.png" /> -->
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdfSrc"
            :page="i"
            ref="pdfs"
            @loaded="pdfLoaded(i)"
            :style="{ width: '100%' }"
          >
          </pdf>
        </div>
      </div>
    </div>
    <div id="signBox">
      <div class="complete">
        <van-button
          @click="handleSignClick"
          type="primary"
          class="operation_btn"
          :disabled="!checkSign"
          >确定</van-button
        >
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="签署校验"
      confirmButtonColor="#5853E9"
      show-cancel-button
      @confirm="phoneConfirm"
    >
      <div class="modal">
        <van-row class="user-links">
          <van-cell-group>
            <van-field
              class="mobile"
              v-model="phone"
              placeholder="请输入手机号"
              type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="12"
              disabled
            />
            <van-field
              class="codeBox"
              v-model="msg"
              placeholder="请输入短信验证码"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="6"
            >
              <van-button
                slot="button"
                class="verification_code"
                size="small"
                @click="getvarify"
                v-if="downcounttime == 0"
                >获取验证码</van-button
              >
              <van-button
                class="downcount"
                slot="button"
                size="small"
                v-if="downcounttime == 1"
                >{{ down }}s后获取</van-button
              >
            </van-field>
          </van-cell-group>
        </van-row>
      </div>
    </van-dialog>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
    <div class="await" v-if="isAwait">
      <div>
        <p>签署审核中</p>
        <p>请等待{{ awaitNum }}s后，再进行其他操作</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import pdf from "vue-pdf";
import Bus from "../../../providers/eventBus";
import Clipboard from "clipboard";
export default {
  name: "signContract",
  data() {
    return {
      value: 1,
      isiOSX: false,
      showPdf: false,
      contidractStyle: { "background-color": "#E3E3E3", height: "400px" },
      show: false,
      dialogShow: false,
      phone: "",
      msg: "",
      phontCorrect: 0,
      down: 60,
      downcounttime: 0,
      spacePop: false,
      getVerifyNum: 0,
      stopGet: "",
      flag: 0,
      close_ClickOverlay: false,
      sealKey: "",
      pdfSrc: "",
      pdfStyle: { "transform-origin": "left top" },
      divSign1: {},
      divSign2: {},
      divSign3: {},
      numPages: undefined,
      checkSign: false,
      img_file: "",
      img_name: "",
      seal_url: "",
      isDisabled: false,
      lock: false,
      loading: false,
      isAwait: false,
      awaitNum: 60,
      pdf_file_url: "",
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    Bus.$on("busSignature", this.handleBusSignature);
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (/Android/gi.test(navigator.userAgent)) {
      window.addEventListener("resize", function () {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView(false);
        }, 1);
      });
    }
    setTimeout(() => {
      this.onLoad();
    }, 200);
    this.getPhone();
  },
  computed: {
    percentValue() {
      return parseInt(parseFloat(this.value) * 100) + "%";
    },
  },
  mounted: function () {
    // this.handleCanvas();
    const navBarHeight =
      document.getElementsByClassName("signContractNav")[0].offsetHeight;
    const signBoxHeight = document.getElementById("signBox").offsetHeight;
    const warpperHeight = document.getElementById("signContract").offsetHeight;
    document.getElementById("contidract").style.height =
      warpperHeight - signBoxHeight - navBarHeight - 28 + "px";
    // this.contidractStyle.height =
    //   document.body.clientHeight - (88 + 28 + 86) + "px";
  },
  components: {
    pdf,
  },
  methods: {
    getPhone() {
      this.$api
        .post("/decoration/member/contract/agent/member/info")
        .then((res) => {
          this.phone = res.username;
        });
      // this.phone = 13300000000
    },
    handleBusSignature(data) {
      this.img_file = data.img_file;
      this.img_name = data.img_name;
      this.checkSign = true;
    },
    stepperOnchange() {
      this.$nextTick(() => {
        this.pdfStyle.transform = `scale(${this.value})`;
        // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
        this.$refs.pdfbox.style.display = "none";
        this.isDisabled = true;
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = "block";
        }, 10);
        setTimeout(() => {
          this.isDisabled = false;
        }, 200);
      });
    },

    async pdfLoaded(i) {
      // not last page
      if (this.numPages !== i) {
        return;
      }
      // 是否展示边框和提示
      // TODO 暂时是写死的
      const flag = true;
      // const flag = ! this.checkSign

      const dom = this.$refs.pdfs[i - 1].$el;
      const dv1 = document.createElement("div");
      const dv2 = document.createElement("div");
      const dv3 = document.createElement("img");
      const span1 = document.createElement("span");
      const span2 = document.createElement("span");
      const span3 = document.createElement("span");
      this.divSign1 = dv1;
      this.divSign2 = dv2;
      this.divSign3 = dv3;

      dom.appendChild(dv1);
      dv1.appendChild(dv2);
      dv1.appendChild(dv3);

      // style
      dv1.style.position = "absolute";
      // TODO 签名和盖章位置写死的
      // 定位是bottom left，所以transform-origin 也需要是 bottom left，否则定位会有问题
      dv1.style["transform-origin"] = "right bottom";
      dv1.style.right = "25px";
      dv1.style.bottom = "108px";
      dv1.style.width = "164px";
      dv2.style.height = "30px";
      dv3.style.height = "80px";
      // TODO
      // dv3.src = 'https://ng.ant.design/assets/img/logo.svg'
      if (this.checkSign == true) {
        dv3.src = this.img_file;
      }
      span3.innerText = "签名";
      dv1.addEventListener("click", this.goSign);

      // scale 基准值0.5
      dv1.style.transform = "scale(0.5)";
      dv2.style.width = "100%";
      if (flag) {
        dv2.style.border = "1px dashed #5853E9";
        dv2.style["border-bottom"] = "none";
        dv2.style["font-size"] = "16px";
        span1.innerText = "点";
        span2.innerText = "我";
        span2.style.color = "#5853E9";
        span1.style.color = "#5853E9";
        span3.style.color = "#5853E9";
        // span3.innerText = '签名'
        dv2.appendChild(span1);
        dv2.appendChild(span2);
        dv2.appendChild(span3);
      }

      dv3.style.width = "100%";
      if (flag) {
        dv3.style.border = "1px dashed #5853E9";
      }

      // this.$nextTick(() => {
      //   this.setScroll()
      // })
      setTimeout(() => {
        this.setScroll();
      }, 500);
    },
    // 合同滚到最后一页底部
    setScroll() {
      const parentDom = this.$refs.contidract;
      const parentDomHeight = parentDom.getBoundingClientRect().height;
      let sumHeight = 0;
      for (let i = 0; i < parentDom.children.length; i++) {
        sumHeight += parentDom.children[i].getBoundingClientRect().height;
      }

      const shouldScrollHeight = sumHeight - parentDomHeight;
      parentDom.scrollTop = shouldScrollHeight;
    },
    goSign() {
      this.$router.push({
        path: "/decoration/deputy/signature",
        query: {},
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      // contract/member/contract/info
      this.$api
        .post("decoration/member/order/contract/info", {
          contract_id: this.$route.query.contract_id,
        })
        .then((data) => {
          if (data.base_file_url) {
            this.pdfSrc =
              location.protocol + "//" + data.base_file_url.split("//")[1];
            this.pdf_file_url = data.base_file_url;
          }
          if (this.pdfSrc) {
            this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
            this.pdfSrc.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSignClick() {
      this.show = true;
    },
    phoneConfirm() {
      if (this.msg == "") {
        this.$toast("验证码为空");
        return;
      }
      this.submit();
    },
    //手机号验证
    verigyPhone() {
      if (this.phone == "") {
        this.$toast("请输入手机号");
      } else {
        if (/^1\d{10}$/.test(this.phone)) {
          this.phontCorrect = 1;
        } else {
          this.$toast("手机号格式错误");
          return false;
        }
      }
    },
    //短信验证
    getvarify() {
      if (this.getVerifyNum < 5) {
        this.getVerifyNum++;
        this.verigyPhone();
        const _this = this;
        if (this.phontCorrect == 1) {
          this.$api
            .post("/pushmsg/index/sms/send-code", {
              mobile: this.phone,
              type: 8,
            })
            .then((res) => {
              _this.down = 60;
              const timer = setInterval(function () {
                _this.down--;
                _this.downcounttime = 1;
                if (_this.down <= 0) {
                  clearInterval(timer);
                  _this.downcounttime = 0;
                }
              }, 1000);
              _this.$toast("验证码已发送，请注意查收");
            })
            .catch((err) => {
              console.log(err);
              this.ThrowError(err);
            });
        }
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var tip = "";
        if (this.getVerifyNum == 5) {
          this.getVerifyNum++;
          this.stopGet = current + 60 * 15;
          //        this.$toast('获取验证码次数已超过5次，请过15分钟之后再试。')
        }
        var ts = this.stopGet - current;
        var mm = Math.floor(ts / 60);
        var ss = ts - mm * 60;
        if (mm && ss) {
          tip =
            "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
        } else if (mm && !ss) {
          tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
        } else if (!mm && ss) {
          tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
        }

        this.$toast(tip);
      }
    },

    async submit() {
      // this.params("", "1", "decorateBackOff");
      this.loading = true;
      if (this.lock) {
        this.loading = false;
        return;
      }
      this.lock = true;
      try {
        let param = {
          mobile: this.phone,
          code: this.msg,
          seal: this.img_name,
          contract_id: this.$route.query.contract_id,
        };
        await this.$api.post("/decoration/member/order/contract/sign", param);
        this.$toast("签名成功");
        this.lock = false;
        this.loading = false;
        this.isAwait = true;
        let awaitDjs = setInterval(() => {
          this.awaitNum = this.awaitNum - 1;
          if (this.awaitNum <= 0) {
            this.awaitNum = 0;
            clearInterval(awaitDjs);
            let await2 = setTimeout(() => {
              this.isAwait = false;
              clearTimeout(await2);
              this.goBack();
            }, 2000);
          }
        }, 1000);
        return;
      } catch (err) {
        this.ThrowError(err);
        this.lock = false;
        this.loading = false;
      }
    },
    ThrowError(err) {
      let keys = Object.keys(err);
      let key = keys[0];
      let message = err.message || err[key][0];
      if (message.slice(0, 10) == "timeout of") {
        this.$toast("网络不给力，请稍候重试");
      } else {
        this.$toast(message);
      }
      return;
    },
    copy() {
      var clipboard = new Clipboard("#copy", {
        text: () => {
          return this.pdf_file_url;
        },
      });
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
#signContract {
  box-sizing: border-box;
  background-color: #fff;
  min-height: 100%;
  font-size: 16px;
  .signContractNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      bottom: 10px;
    }
  }
  .contentBox {
    // overflow: auto;
  }
  #contidract {
    &::-webkit-scrollbar {
      display: none;
    }
    overflow: scroll;
    position: relative;
  }

  .stepper-warpper {
    height: 28px;
    position: relative;
    background-color: #fff;
    .van-stepper {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .percent {
      position: absolute;
      height: 28px;
      line-height: 28px;
      width: 40px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      background-color: #f2f3f5;
      font-size: 13px;
    }
  }
  #signBox {
    padding-top: 12px;
    background-color: #f5f6f7;
    // height: 200px;
    #signNameCanvasBox {
      width: 100%;
      height: 98px;
      // margin-top: 6px;
      background: #fff;
      .signature {
        color: #f9591b;
        font-weight: 600;
        font-size: 20px;
        line-height: 98px;
        text-align: center;
      }
      .canvas {
        display: none;
      }
    }

    .complete {
      margin: 0 12px;
      padding-bottom: 24px;
      .operation_btn {
        background-color: #5853e9;
        color: #fff;
        border: none;
        width: 100%;
        margin: 0 auto;
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
      }
    }
  }
  .verification_code {
    width: auto;
    border-radius: 6px;
    color: #ffffff;
    height: 38px;
    font-size: 16px;
    background-color: #5853e9;
    border: 1px solid #ebedf0;
  }
  .downcount {
    width: 100px;
    border-radius: 6px;
    color: #cccccc;
    height: 40px;
    font-size: 16px;
    background-color: #f5f6f7;
    border: 1px solid #ebedf0;
  }
  .codeBox {
    padding: 5px 16px 5px;
    // border-bottom: 1px solid #f4f5f7;
  }
  .van-field__control {
    font-size: 16px;
  }
  .van-field__control:disabled {
    // color: #969799;
    color: #000;
    // -webkit-text-fill-color: #969799;
    -webkit-text-fill-color: #000;
    background-color: transparent;
    opacity: 1;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
  .van-dialog {
    width: 274px;
    border-radius: 3px;
    .van-dialog__content {
      .van-dialog__message {
        font-size: 16px;
        padding: 30px 49px;
      }
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
  .await {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      background-color: #ffffff;
      width: 60%;
      border-radius: 12px;
      padding: 20px;
      p {
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
    }
  }
}
.van-dialog__cancel {
  color: #999999 !important;
}
</style>
